import _regeneratorRuntime from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function presentToast(_x) {
  return _presentToast.apply(this, arguments);
}

function _presentToast() {
  _presentToast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _presentToast.apply(this, arguments);
}

var AlertHelper = /*#__PURE__*/function () {
  function AlertHelper() {
    _classCallCheck(this, AlertHelper);
  }

  _createClass(AlertHelper, [{
    key: "showAlert",
    value: function showAlert(options) {
      presentToast(options);
    }
  }, {
    key: "hideAlert",
    value: function hideAlert() {}
  }]);

  return AlertHelper;
}();

export default new AlertHelper();